
//买家开关同步：isShowPrice(遮价)/isBatchEditCustom(批量自定义编码)/isRetail(拆零)/logistics(默认配送)
//单一数据源 = localStorage.buyerInfo；buyerFlags 是其响应式影子（Vue.observable），
//管理员后台改客户档案后，商城端无需退出重登：路由切换/切回标签页时节流拉取 GetCurrentUserInfo 合并这4个键。
import Vue from 'vue';
import Api from '../../api/index.js';

const SYNC_KEYS = ['isShowPrice', 'isBatchEditCustom', 'isRetail', 'logistics'];
const THROTTLE_MS = 60 * 1000;      //60s 内不重复请求
const SYNC_AT_KEY = 'buyerInfoSyncAt';

export const buyerFlags = Vue.observable({
  isShowPrice: undefined,           //undefined => 显示价格（兼容旧会话，同旧 hidePriceActive 语义）
  isBatchEditCustom: 0,
  isRetail: 0,
  logistics: 0,
});

export function readBuyerInfo() {
  try { return JSON.parse(localStorage.getItem('buyerInfo') || 'null'); } catch (e) { return null; }
}

export function syncBuyerFlagsFromStorage() {
  const info = readBuyerInfo();
  SYNC_KEYS.forEach(k => { buyerFlags[k] = info ? info[k] : (k === 'isShowPrice' ? undefined : 0); });
}
syncBuyerFlagsFromStorage();        //模块加载即初始化（首屏用缓存值，行为与之前一致）

export function hidePriceActive() {
  return buyerFlags.isShowPrice === false;
}

let inFlight = null;                //单飞：并发导航只发一个请求
export function refreshBuyerInfo(force) {
  //未登录/无 buyerInfo 不请求，也不凭空造 buyerInfo
  if (!localStorage.getItem('token') || !readBuyerInfo()) return Promise.resolve(false);
  if (inFlight) return inFlight;
  const last = Number(localStorage.getItem(SYNC_AT_KEY) || 0);
  if (!force && Date.now() - last < THROTTLE_MS) return Promise.resolve(false);
  inFlight = Api.getCurrentUserInfo().then(res => {
    if (res && res.data && res.data.status && res.data.data) {
      const d = res.data.data;
      const cur = readBuyerInfo() || {};
      let changed = false;
      SYNC_KEYS.forEach(k => {
        //旧后端响应缺字段时不覆盖
        if (d[k] !== undefined && cur[k] !== d[k]) { cur[k] = d[k]; changed = true; }
      });
      //只合并这4个键，isHllAuth 等其余字段全保留
      if (changed) localStorage.setItem('buyerInfo', JSON.stringify(cur));
      localStorage.setItem(SYNC_AT_KEY, String(Date.now()));
      syncBuyerFlagsFromStorage();
      return true;
    }
    return false;                   //401等失败：全局拦截器已处理，这里静默
  }).catch(() => false)             //网络断等拦截器抛出的异常
    .then(ok => { inFlight = null; return ok; });
  return inFlight;
}

//跨标签页：其它标签页登录/登出改写 buyerInfo 时立即跟随
window.addEventListener('storage', e => {
  if (e.key === 'buyerInfo' || e.key === null) syncBuyerFlagsFromStorage();
});
//切回标签页：同样受 60s 节流
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') { syncBuyerFlagsFromStorage(); refreshBuyerInfo(); }
});
